import CardWrapper from "components/commons/cardWrapper/CardWrapper";
import { strings } from "intl/fa";
import infoStyles from "./SponsoredInfo.module.scss";
import Footer from "components/commons/footer/Footer";
import { Divider, DividerThickness, NewButton, NewButtonSize } from "@bale/ui";
import { Bubble } from "components/content/sponsoredMessage/steps/4_preview/Bubble";
import { useAppSelector } from "utils/store";
import styles from "./SponsoredFinalStep.module.scss";
import { digitsToHindi, formatStrings, toMoneyFormat } from "@bale/utils";
import { useRequest } from "hooks/useRequest";
import { submitAdOrderThunk } from "core/orderAd/orderAd.thunk";
import * as Sentry from "@sentry/react";
import { useCalculatedPrice } from "hooks/useCalculatedPrice";
import { AdSpot } from "core/orderAd/orderAd.entity";
import { useEffect, useMemo } from "react";

export const SponsoredFinalStep = () => {
  const orderAdInfo = useAppSelector((state) => state.orderAd.info);

  const loading = useAppSelector((state) => state.orderAd.orderLoading);
  const { sendRequest: submitAdOrder } = useRequest(submitAdOrderThunk);

  function traceOrdersInSentry() {
    Sentry.captureException({
      message: `Ordering ${"ad"}`,
      extra: { adData: JSON.stringify(orderAdInfo) },
    });
  }

  const submit = () => {
    traceOrdersInSentry();
    if (!loading) {
      submitAdOrder();
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl);
      }
    }
  };

  const { finalBasePrice, loading: priceLoading } = useCalculatedPrice({
    link: orderAdInfo.link || "",
    spot: orderAdInfo.spot || AdSpot.AdSpotSponsoredMessage,
    viewCount: orderAdInfo.view_count || 0,
    clickCount: orderAdInfo.view_count || 0,
  });

  const imageUrl = orderAdInfo.croppedImageURL;

  return (
    <>
      <div className={infoStyles.Content}>
        <CardWrapper className={infoStyles.Card}>
          <p className={infoStyles.inputTitle}>
            {strings.sponsored_messages.finalStep.info}
          </p>

          <div className={styles.container}>
            <Bubble
              caption={orderAdInfo.description || ""}
              imageSrc={imageUrl}
              button_link={orderAdInfo.link}
              button_title={orderAdInfo.link_title}
            />
            <div className={styles.viewContainer}>
              <p className={styles.viewCount}>
                {strings.sponsored_messages.finalStep.view_count}
              </p>
              <p className={styles.count}>
                {digitsToHindi(
                  toMoneyFormat(
                    formatStrings(orderAdInfo.view_count?.toString())
                  )
                )}
              </p>
            </div>
            <Divider
              className={styles.divider}
              thickness={DividerThickness.Thin}
            />
            {!priceLoading ? (
              <>
                <p className={styles.perUser}>
                  {formatStrings(
                    strings.sponsored_messages.finalStep.each_view,
                    {
                      price: digitsToHindi(finalBasePrice.toString()),
                    }
                  )}
                </p>
                {orderAdInfo.view_count && (
                  <div className={styles.priceCcontainer}>
                    <p className={styles.viewCount}>
                      {strings.sponsored_messages.finalStep.finalPrice}
                    </p>
                    <p className={styles.count}>
                      {digitsToHindi(
                        toMoneyFormat(
                          finalBasePrice * orderAdInfo.view_count + ""
                        )
                      )}
                    </p>
                  </div>
                )}
              </>
            ) : (
              <p className={styles.perUser}>
                {strings.sponsored_messages.calculating}
              </p>
            )}
          </div>
        </CardWrapper>
      </div>
      <Footer>
        <NewButton
          loading={loading}
          onClick={submit}
          className={infoStyles.Button}
          size={NewButtonSize.LARGE}
        >
          {strings.common.button.final_submit}
        </NewButton>
      </Footer>
    </>
  );
};
